/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbq
 * @LastEditTime: 2021-01-15 14:36:31
 * @Description: file content
 */
/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import OriginSwitch from 'bee-switch';
import Popover from '../Popover';
import { getSysFieldid } from '@platform/api';

require('bee-switch/build/Switch.css');
require('./index.less');

export default class Switch extends Component {
    constructor(props) {
        super(props);
        this.state = { content: '' };
    }

    show = v => {
        let content = '已关闭';
        if (v) {
            content = '开启成功';
        }
        this.setState({ content: content });
    };

    handleKeyDown = e => {
        let { onKeyDown } = this.props;
        if (e.keyCode === 32) {
            e.stopPropagation();
            e.preventDefault();
            let switchDom = this.dom && this.dom.firstElementChild;
            switchDom && switchDom.click();
        }

        onKeyDown && onKeyDown(e);
    };

    render() {
        let { onChange, enterKeyDown = false, onKeyDown, onEnter, fieldid, ...others } = this.props;
        fieldid = getSysFieldid(fieldid);
        return this.props.showTip ? (
            <Popover placement="right" trigger="click" content={this.state.content} className="switch-popover">
                <div
                    style={{ display: "inline-block" }}
                    className={"switch-hotkey-wrapper"}
                    onKeyDown={e => {
                        if ([e.keyCode, e.which, e.charCode].find(e => e === 13) || e.key === "Enter") {
                            onEnter && onEnter({ e: e });
                        }
                    }}
                >
                    <OriginSwitch
                        fieldid={fieldid ? fieldid : null}
                        onChange={v => {
                            this.show(v);
                            onChange && onChange(v);
                        }}
                        enterKeyDown={enterKeyDown}
                        ref={dom => {
                            this.dom = ReactDOM.findDOMNode(dom);
                        }}
                        {...others}
                        onKeyDown={this.handleKeyDown}
                    />
                </div>
            </Popover>
        ) : (
                <div
                    style={{ display: "inline-block" }}
                    className={"switch-hotkey-wrapper"}
                    onKeyDown={e => {
                        if ([e.keyCode, e.which, e.charCode].find(e => e === 13) || e.key === "Enter") {
                            onEnter && onEnter({ e: e });
                        }
                    }}
                >
                    <OriginSwitch
                        fieldid={fieldid ? fieldid : null}
                        ref={dom => {
                            this.dom = ReactDOM.findDOMNode(dom);
                        }}
                        {...others}
                        enterKeyDown={enterKeyDown}
                        onKeyDown={this.handleKeyDown}
                        onChange={onChange}
                    />
                </div >
            );
    }
}
